module.exports = __webpack_public_path__ + "img/gallery03.ff01589a.jpg";